export enum UserChallenges {
  SetOrg = "set_org",
  ConfirmPhone = "confirm_phone",
  ResetPassword = "reset_password",
  CompleteProfile = "complete_profile",
}
